import React, { useState } from "react";
import { Data } from "./packagData";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Card,
  CardHeader,
  CardBody,
  Typography,
  Button,
  CardFooter,
  Dialog,
} from "@material-tailwind/react";
import { PaintBrushIcon, CodeBracketIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import CheckoutForm from "./checkoutForm";

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="h-3 w-3"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 12.75l6 6 9-13.5"
      />
    </svg>
  );
}

export function ProductsCard() {
  const [t] = useTranslation("global");
  const View = ({ packageName, packages }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen((cur) => !cur);
    const DataPackageName = Data[packageName];
    const DataPackage = [DataPackageName[packages]];
    const [selectedItems, setSelectedItems] = useState([]);

    return (
      <>
        {DataPackage.map((item, key) => {
          const DataContent = item.content;

          const selectPrice = selectedItems.reduce((acc, itemId) => {
            const selectedContent = DataContent.filter((i) => i.id === itemId);
            return acc.concat(selectedContent);
          }, []);
          const totalPrice = selectPrice.reduce((acc, currentItem) => {
            return acc + currentItem.price;
          }, 0);

          const total = item.price + totalPrice;

          return (
            <div key={key}>
              <Card
                color="blue"
                variant="gradient"
                className="w-full max-w-[20rem] p-8"
              >
                <CardHeader
                  floated={false}
                  shadow={false}
                  color="transparent"
                  className="m-0 mb-8 rounded-none border-b border-white/10 pb-8 text-center"
                >
                  <Typography
                    variant="small"
                    color="white"
                    className="font-normal uppercase"
                  >
                    {item[t("packages.title")]}
                  </Typography>
                  <Typography
                    variant="h1"
                    color="white"
                    className="mt-6 flex justify-center gap-1 text-4xl font-normal"
                  >
                    <span className=" text-2xl">$</span>
                    {total}{" "}
                  </Typography>
                </CardHeader>
                <CardBody className="p-0">
                  <ul className="flex flex-col gap-4">
                    {DataContent.map((i) => {
                      const isSelected = selectedItems.includes(i.id);

                      return (
                        <li
                          key={i.id}
                          onClick={() => {
                            setSelectedItems((prevState) => {
                              if (prevState.includes(i.id)) {
                                return prevState.filter(
                                  (item) => item !== i.id
                                );
                              } else {
                                return [...prevState, i.id];
                              }
                            });
                          }}
                          className="flex items-center gap-4 cursor-pointer"
                        >
                          <span
                            className={`rounded-full border  border-white/20 ${
                              isSelected ? "bg-green-500" : "bg-white/20"
                            }  p-1`}
                          >
                            <CheckIcon />
                          </span>
                          <Typography className="font-normal">
                            {i[t("packages.title")]} = {i.price}
                          </Typography>
                        </li>
                      );
                    })}
                  </ul>
                </CardBody>
                <CardFooter className="mt-12 p-0">
                  <Button
                    size="lg"
                    color="white"
                    className="hover:scale-[1.02] focus:scale-[1.02] active:scale-100"
                    ripple={false}
                    fullWidth={true}
                    onClick={handleOpen}
                  >
                    Buy Now
                  </Button>
                </CardFooter>
              </Card>
              <Dialog
                size="xs"
                open={open}
                handler={handleOpen}
                className="bg-transparent shadow-none"
              >
                <CheckoutForm price={total} title={item[t("packages.title")]} />
              </Dialog>
            </div>
          );
        })}
      </>
    );
  };
  const Programming = () => {
    return (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <View packages={"package1"} packageName={"programming"} />
          <View packages={"package2"} packageName={"programming"} />
          <View packages={"package3"} packageName={"programming"} />
        </div>
      </>
    );
  };
  const Design = () => {
    return (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <View packages={"package1"} packageName={"design"} />
          <View packages={"package2"} packageName={"design"} />
          <View packages={"package3"} packageName={"design"} />
        </div>
      </>
    );
  };

  const data = [
    {
      label: "programming",
      value: "البرمجة",
      icon: CodeBracketIcon,
      desc: <Programming />,
    },
    {
      label: "designs",
      value: "التصميم",
      icon: PaintBrushIcon,
      desc: <Design />,
    },
  ];
  return (
    <Tabs dir={t("dir")} value="البرمجة">
      <div className="flex flex-col items-center justify-center ">
        <div className="text-center ">
          <Typography
            variant="h4"
            color="blue"
            textGradient
            className="text-2xl"
          >
            {t("home.products")}
          </Typography>
          <Typography color="gray" className="mt-1 font-normal">
            {t("home.products_desc")}
          </Typography>
        </div>
        <div className="border-blue-500 rounded-lg border-2 md:w-[25%] w-[90%] m-5"></div>
      </div>
      <TabsHeader>
        {data.map(({ label, value, icon }) => (
          <Tab key={value} value={value}>
            <div className="flex items-center gap-2">
              {React.createElement(icon, { className: "w-5 h-5" })}
              {t(`home.${label}`)}
            </div>
          </Tab>
        ))}
      </TabsHeader>
      <TabsBody>
        {data.map(({ value, desc }) => (
          <TabPanel key={value} value={value}>
            {desc}
          </TabPanel>
        ))}
      </TabsBody>
    </Tabs>
  );
}
